import { render, staticRenderFns } from "./BuyBoxOfferNewPresentation.vue?vue&type=template&id=9873bbb6&scoped=true"
import script from "./BuyBoxOfferNewPresentation.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxOfferNewPresentation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxOfferNewPresentation.vue?vue&type=style&index=0&id=9873bbb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9873bbb6",
  null
  
)

export default component.exports